import { transformDateValue } from 'core/js/FormUtils';
export const getMfdeliverypriorityView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mfdeliverypriorityList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Business Id","fieldValue":transformDataValue(data.businessid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mfdeliverypriorityList.push(card);
  })
  return mfdeliverypriorityList;
}